import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  FOG_800M_COLOR,
  FOG_1600M_COLOR,
  FOG_3000M_COLOR,
  NO_FOG_COLOR,
  NO_DATA_COLOR
} from '../../theme/colors';
import * as styles from '../../styles/MapPageStyles';

interface HorizontalLegendProps {
  formatVisibility: (value: number) => string;
}

const HorizontalLegend: React.FC<HorizontalLegendProps> = ({ formatVisibility }) => {
  return (
    <Box sx={styles.horizontalLegendContainerStyles}>
      {/* Title */}
      <Typography
        variant="subtitle1"
        sx={styles.horizontalLegendTitleStyles}
      >
        Visibility
      </Typography>

      {/* Current | Forecast indicator on its own line */}
      <Box sx={styles.horizontalLegendStatusRowStyles}>
        <Box sx={styles.legendIconContainerStyles}>
          <svg width="100%" height="100%" viewBox="0 0 16 16">
            <defs>
              <clipPath id="horizontalLegendLeft">
                <rect x="0" y="0" width="8" height="16" />
              </clipPath>
              <clipPath id="horizontalLegendRight">
                <rect x="8" y="0" width="8" height="16" />
              </clipPath>
            </defs>
            <circle cx="8" cy="8" r="7" fill="#888" clipPath="url(#horizontalLegendLeft)" />
            <circle cx="8" cy="8" r="7" fill="#666" clipPath="url(#horizontalLegendRight)" />
            <circle cx="8" cy="8" r="7" fill="none" stroke="#FFF" strokeWidth="1.5" />
            <line x1="8" y1="1" x2="8" y2="15" stroke="#FFF" strokeWidth="1" opacity="0.7" />
          </svg>
        </Box>
        <Typography variant="caption" sx={styles.legendTextStyles}>
          Current | Forecast
        </Typography>
      </Box>

      {/* Horizontal divider */}
      <Box sx={{
        width: '100%',
        height: '1px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        my: 1
      }} />

      {/* Visibility items in horizontal layout with wrapping */}
      <Box sx={styles.horizontalLegendItemsContainerStyles}>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(FOG_800M_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>{`≤ ${formatVisibility(800)}`}</Typography>
        </Box>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(FOG_1600M_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>{`≤ ${formatVisibility(1600)}`}</Typography>
        </Box>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(FOG_3000M_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>{`≤ ${formatVisibility(3000)}`}</Typography>
        </Box>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(NO_FOG_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>&gt; 3000 m</Typography>
        </Box>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(NO_DATA_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>No data</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default HorizontalLegend;
